<template>
  <div>
    <E4HQuiz></E4HQuiz>
    <E4HButton :design="buttondesign" :title="buttontitle"></E4HButton>
  </div>
</template>

<script>
//import E4HButton from './components/E4HButton.vue'
//import jQuery from 'jquery';

import E4HButton from "@/components/E4HButton";
import E4HQuiz from "@/components/E4HQuiz";

const RESULT_PERFORMANCE="performance";
const RESULT_SLEEP = "sleep";
const RESULT_METABOLIC = "metabolic";
const RESULT_TAP = "tapdevice";

let e4hData = window.e4hData || {params_sleep:"", params_metabolic:"", params_performance:"", params_tap:""};

let gQuiz = {
  questions: {
    10: {
      text: "Welchen Bereich in Ihrem Leben wollen Sie optimieren?",
      type: "singlechoice",
      responses: [
        {text: "Schlafverhalten verbessern", track: "sleep"},
        {text: "Performance steigern", track: "performance"},
        {text: "Stoffwechsel aktivieren", track: "metabolic"},
        {text: "Allgemeines Wohlbefinden steigern", track: "overall"}
      ],
      nextIndex: 20
    },
    20: {
      text: "Geschlecht",
      type: "singlechoice",
      responses: [
        {text: "Männlich"},
        {text: "Weiblich"},
        {text: "Andere"}
      ],
      nextIndex: 30,
      prevIndex: 10
    },
    30: {
      text: "Alter",
      type: "text",
      nextIndex: 40,
      prevIndex: 20
    },
    40: {
      text: "Wie viel Sport machen Sie?",
      type: "singlechoice",
      responses: [
        {text: "Mehrmals pro Woche"},
        {text: "Ein- bis Zweimal pro Woche"},
        {text: "Gar nicht"}
      ],
      nextIndex: 50,
      prevIndex: 30
    },
    50: {
      text: "Nehmen Sie Nahrungsergänzungsmittel?",
      type: "singlechoice",
      responses: [
        {text: "Ja"},
        {text: "Nein"}
      ],
      prevIndex: 40
    },
    110: {
      text: "Haben sie Schlafprobleme?",
      type: "singlechoice",
      responses: [
        {text: "Häufig"},
        {text: "Selten"},
        {text: "Nie"},
      ],
      nextIndex: 120,
      prevIndex: 50
    },
    120: {
      text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
      type: "singlechoice",
      responses: [
        {text: "Ja"},
        {text: "Nein"},
      ],
      nextIndex: 130,
      prevIndex: 110
    },
    130: {
      text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
      type: "singlechoice",
      responses: [
        {text: "Ja"},
        {text: "Nein"},
      ],
      prevIndex: 120
    }
  },

  /*
  addonQuestions: {
      performance: {
          110: {
              text: "Haben sie Schlafprobleme?",
              type: "singlechoice",
              responses: [
                  {text: "Häufig"},
                  {text: "Selten"},
                  {text: "Nie"},
              ],
              nextIndex: 120,
              prevIndex: 50
          },
          120: {
              text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
              type: "singlechoice",
              responses: [
                  {text: "Ja"},
                  {text: "Nein"},
              ],
              nextIndex: 130,
              prevIndex: 110
          },
          130: {
              text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
              type: "singlechoice",
              responses: [
                  {text: "Ja"},
                  {text: "Nein"},
              ],
              prevIndex: 120
          }
      },
      overall: {
          110: {
              text: "Haben sie Schlafprobleme?",
              type: "singlechoice",
              responses: [
                  {text: "Häufig"},
                  {text: "Selten"},
                  {text: "Nie"},
              ],
              nextIndex: 120,
              prevIndex: 50
          },
          120: {
              text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
              type: "singlechoice",
              responses: [
                  {text: "Ja"},
                  {text: "Nein"},
              ],
              nextIndex: 130,
              prevIndex: 110
          },
          130: {
              text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
              type: "singlechoice",
              responses: [
                  {text: "Ja"},
                  {text: "Nein"},
              ],
              prevIndex: 120
          }
      }
  },
  */

  results: {
    [RESULT_SLEEP]: {
      name: 'Mikronährstoff-Schlafverhalten-Analyse',
      description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf 5,00 € bis 15,00 €',
      productId: 186,
      image: '/wp-content/uploads/2019/05/minimal-300x300.png',
      params: e4hData.params_sleep
    },
    [RESULT_METABOLIC]: {
      name: 'Mikronährstoff-Stoffwechsel-Analyse',
      description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf 5,00 € bis 15,00 €',
      productId: 189,
      image: '/wp-content/uploads/2019/05/optimal-300x300.png',
      params: e4hData.params_metabolic
    },
    [RESULT_PERFORMANCE]: {
      name: 'Mikronährstoff-Performance-Analyse',
      description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf 5,00 € bis 15,00 €',
      productId: 188,
      image: '/wp-content/uploads/2019/05/basisplus-300x300.png',
      params: e4hData.params_performance
    },
    [RESULT_TAP]: {
      name: 'TAP® Device',
      description: 'Wir schicken Ihnen einen TAP® Device zu, mit diesem können Sie ganz einfach und schmerzfrei selbst Blut am Oberarm abnehmen.',
      productId: 14752,
      image: 'https://energyforhealth.kunden.adlung.at/wp-content/uploads/2020/01/tapdevice-300x300.png',
      params: e4hData.params_tap
    }
  }


};

export default {
  name: 'EnergyForHealth',
  components: {
    E4HQuiz,
    E4HButton
  },
  props: [
    "buttondesign",
    "buttontitle"
  ],
  data: function () {
    return {
      quizVisible: false,
    }
  },
  mounted: function() {
    //console.log(this.$el.attributes);
    //console.log(this.$parent.attributes);
  },
  computed: {
  },
}
</script>


<style>


</style>
